import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const validateForm = (formData) => {
	const newErrors = {};
	const fullNameRegex = /^[a-zA-Z\s'-]+$/;
	const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

	// Full Name Validation
	if (!formData.fname) {
		newErrors.fname = "Name is required";
	} else if (!fullNameRegex.test(formData.fname)) {
		newErrors.fname = "Name must only contain letters, spaces, apostrophes, and hyphens";
	} else if (formData.fname.length > 100) {
		newErrors.fname = "Name must not exceed 100 characters";
	}

	// Zip Validation
	if (!formData.zip) {
		newErrors.zip = "Zip is required";
	} else if (formData.zip.length > 20) {
		newErrors.zip = "Zip must not exceed 20 characters";
	}

	// Email Validation
	if (!formData.email) {
		newErrors.email = "E-Mail is required";
	} else if (!emailRegex.test(formData.email)) {
		newErrors.email = "Invalid email address";
	} else if (formData.email.length > 50) {
		newErrors.email = "E-Mail must not exceed 50 characters";
	}

	// Phone Validation (Office or Mobile - at least one is required)
	if (!formData.phone && !formData.mphone) {
		newErrors.phone = "At least one phone number (Office or Mobile) is required";
	} else {
		// Validate Office Phone if provided
		if (formData.phone) {
			const parsedPhone = parsePhoneNumberFromString(
				formData.phone,
				formData.country === "USA" ? "US" : formData.country
			);
			if (!parsedPhone || !parsedPhone.isValid()) {
				newErrors.phone = "Invalid office phone number";
			}
		}

		// Validate Mobile Phone if provided
		if (formData.mphone) {
			const parsedMPhone = parsePhoneNumberFromString(
				formData.mphone,
				formData.country === "USA" ? "US" : formData.country
			);
			if (!parsedMPhone || !parsedMPhone.isValid()) {
				newErrors.mphone = "Invalid mobile phone number";
			}
		}
	}

	return newErrors;
};
